// extracted by mini-css-extract-plugin
export default {"container":"VUEtyeob","mobile":"mobile","desktop":"desktop","ears":"pD6zUpEn","buttonWrapper":"J5NaUHBo","buttonText":"OSHkOKpF"};